<template>

  <div class="p-5 flex flex-col flex-grow gap-2">

    <div class="flex flex-col text-black pb-5">
      <h2 class="text-2xl font-bold">Newsletter Import</h2>
      <p>
        <span class="text-md">Dies ist der Import für Newsletter Excel Tabellen. </span>
        <span class="text-md">Wählen Sie zuerst eine Excel-Datei aus. </span>
        <span class="text-md">Sie können dann noch auswählen, welche Artikel Sie importieren möchten. </span>
      </p>
    </div>


    <div class="flex flex-col gap-2 flex-shrink-0">
      <div class="flex items-center justify-center">
        <label @change="onFileChange"
               class=" text-center bg-trader-dark-gray hover:bg-trader-blue hover:text-black w-full rounded p-2 ">
          <input type="file" class="hidden">
          Datei auswählen
        </label>
      </div>

    </div>

    <div v-if="tableData" class="flex gap-2 justify-center items-center">
      <div class=" flex gap-2 ">
        <span>Für alle Projekte auswählen </span>
        <select
            class="outline-0 border border-bg-trader-input-border border-header p-1 w-[200px]  shadow-inner-2 text-gray-500"
            v-model="projectIdForAll" @change="choseAllProjekts">
          <option v-for="projekt in projekts" :key="projekt.id" :value="projekt.id">{{ projekt.name }}</option>
        </select>
        <!-- <input type="checkbox" @click="choseAllProjekts">-->
      </div>
    </div>
    <div v-if="tableData" class="flex flex-col gap-2 overflow-hidden">

      <!-- Tabelle -->
      <div class="  flex flex-grow overflow-hidden">
        <div class="overflow-auto outline-0" @click="focus" ref="tableContainer" tabindex="0">
          <table class="w-full rounded  select-none table-fixed flex-grow outline-0">

            <thead class="sticky top-0 ">
            <tr class="bg-trader-darker-gray  text-black h-10 text-left ">
              <th class="px-2 w-[100px] relative text-nowrap overflow-hidden text-ellipsis">
                Art.Nr
              </th>

              <th class="px-2 w-[150px]   relative text-nowrap overflow-hidden text-ellipsis">
                Magazine Name (Excel)
              </th>

              <th class="px-2 flex-grow  relative text-nowrap overflow-hidden text-ellipsis">
                Magazine
              </th>
              <th class="px-2 flex-shrink-0 w-[80px]  relative text-nowrap overflow-hidden text-ellipsis">
                Existiert
              </th>


            </tr>

            </thead>

            <tbody>
            <tr v-for="(row, rowIndex) in tableData" :key="rowIndex" class="text-black h-8 text-left" :class="{
                'bg-trader-dark-gray': rowIndex % 2 !== 0,
                'bg-trader-gray': rowIndex % 2 === 0,
                'opacity-30 bg-trader-dark-gray': !row.import && rowIndex % 2 !== 0,
                'opacity-30 bg-trader-gray': !row.import && rowIndex % 2 === 0,
              }">
              <td class=" overflow-hidden whitespace-nowrap text-ellipsis flex h-8 gap-2 items-center "
                  :title="row.articleNumber">
                <div class="p-2 items-center " @click="tableData[rowIndex].import = !tableData[rowIndex].import">
                  <input class="" type="checkbox" v-model="tableData[rowIndex].import">
                </div>
                <span :title="row.articleNumber">
                     {{ row.articleNumber }}
                  </span>

              </td>
              <td class="px-2 overflow-hidden whitespace-nowrap text-ellipsis ">
                  <span :title="row.magazineName">
                        {{ row.magazineName }}
                  </span>
              </td>
              <td class="px-2 overflow-hidden whitespace-nowrap text-ellipsis gap-2 justify-center items-center  h-8 inline-flex">

                <div v-if="tableData[rowIndex].import"
                     class="flex  justify-center items-center gap-2  flex-grow overflow-hidden">
                  <select v-model="tableData[rowIndex].projectId"
                          class="outline-0 border border-bg-trader-input-border border-header p-1   shadow-inner-2 text-gray-500"
                          @change="onSelectProject(rowIndex)">

                    <option value="0">Projekt auswählen</option>
                    <option v-for="projekt in projekts" :key="projekt.id" :value="projekt.id">{{
                        projekt.name
                      }}
                    </option>

                  </select>
                  <button title="Projekt von oben übernehmen"
                          class="p-1 hover:bg-trader-blue w-[25px] hover:text-white"
                          @click="copySelectFromTopProject(rowIndex)"><i v-if="rowIndex > 0"
                                                                         class="fa-solid fa-arrow-turn-up"></i>
                  </button>
                </div>

                <div v-if="tableData[rowIndex].import"
                     class="flex justify-center  items-center gap-2 flex-grow overflow-hidden">
                  <select v-model="tableData[rowIndex].magazineId"
                          class="outline-0 border border-bg-trader-input-border border-header p-1   shadow-inner-2 text-gray-500"
                          @change="onSelectMagazine(rowIndex)">
                    <option value="0">Magazin auswählen</option>
                    <option v-for="magazine in tableData[rowIndex].magazines" :key="magazine.id" :value="magazine.id">
                      {{
                        magazine.name
                      }}
                    </option>
                  </select>
                  <button title="Magazine von oben übernehmen"
                          class="p-1 w-[25px] hover:bg-trader-blue hover:text-white"
                          @click="copySelectFromTopMagazine(rowIndex)"><i v-if="rowIndex > 0"
                                                                          class="fa-solid fa-arrow-turn-up"></i>
                  </button>
                </div>

                <div v-if="tableData[rowIndex].import"
                     class=" flex flex-grow  overflow-hidden justify-center items-center">
                  <select v-if="tableData[rowIndex].markets.length > 0" v-model="tableData[rowIndex].marketId"
                          class="outline-0 border border-bg-trader-input-border border-header p-1   shadow-inner-2 text-gray-500">
                    <option value="0">Markt auswählen</option>
                    <option v-for="market in tableData[rowIndex].markets" :key="market.id" :value="market.id">
                      {{ market.name }}
                      {{ market.description }}
                    </option>
                  </select>
                </div>
              </td>
              <td class="px-2 overflow-hidden whitespace-nowrap text-ellipsis text-right">
                <div v-if="tableData[rowIndex].import" class="flex justify-center items-center">
                  <span v-if="tableData[rowIndex]?.exists" class="text-green-500"><i
                      class="fa-solid fa-check"></i></span>
                  <span v-else class="text-red-500"><i class="fa-solid fa-xmark"></i></span>
                </div>
              </td>
            </tr>
            </tbody>

          </table>
        </div>
      </div>

      <TRProgress class="flex-shrink-0" :progress="processesBar"></TRProgress>
      <div class=" flex flex-col gap-2  flex-shrink-0 p-2">
        <div class="flex">
          <span class="p-1 w-[150px]">Projekt:</span>

          <select
              class="outline-0 border border-bg-trader-input-border border-header p-1 w-full  shadow-inner-2 text-gray-500"
              v-model="projectId" @change="getMagazinesWithIdAndName">
            <option v-for="projekt in projekts" :key="projekt.id" :value="projekt.id">{{ projekt.name }}</option>

          </select>

        </div>
        <div class="flex">
          <span class="p-1 w-[150px]">Magazine:</span>

          <select
              class="outline-0 border border-bg-trader-input-border border-header p-1 w-full  shadow-inner-2 text-gray-500"
              v-model="magazineId">
            <option v-for="magazine in magazines" :key="magazine.id" :value="magazine.id">{{ magazine.name }}</option>
          </select>
        </div>
        <div v-if="!readyToImport" class="text-red-500">
          Bitte wählen Sie zuerst alle Magazine aus, bevor Sie die Artikel importieren.
        </div>
        <!-- Button to newsletterImport -->
        <!-- v-if="readyToImport" -->
        <div class="flex justify-center">
          <button class="bg-trader-red text-black p-2 rounded" @click="newsletterImport">Importieren</button>
        </div>

      </div>


    </div>
  </div>

</template>

<script setup lang="js">
import {mutation, query} from "@/graphql";
import {computed, onMounted, ref} from "vue";
import axios from "axios";
import {eventBus} from "@/application/EventBus";
import ShowReport from "@/components/Dialogs/ShowReport.vue";
import TRProgress from "@/components/Base/v2/TRProgress.vue";


const props = defineProps({
  magazineId: {
    type: Number,
    default: 0
  },
  projectId: {
    type: Number,
    default: 0
  }
});
const projekts = ref([]);
const magazines = ref([]);
const pages = ref([]);
const markets = ref([]);

const header = ref(["Art.Nr", "Seite", "Magazine"]);
const data = ref([
  {articleNumber: "001", page: 12, magazine: "Tech Today"},
  {articleNumber: "002", page: 5, magazine: "Science Weekly"},
  {articleNumber: "003", page: 8, magazine: "History Monthly"},
  {articleNumber: "004", page: 20, magazine: "Travel Guide"},
  {articleNumber: "005", page: 15, magazine: "Cooking Tips"}
]);


const projectId = ref(0);
const magazineId = ref(0);
const pageId = ref(0);
const pagePosition = ref(0);
const selectedFile = ref(null);
const loading = ref(false);
const tableData = ref(null);
const projectIdForAll = ref(0);
const processesBar = ref(0);

onMounted(async () => {
  projectId.value = props.projectId;
  await getProjectsWithIdAndName();
  magazineId.value = props.magazineId;

  await getMagazinesWithIdAndName();

});

function choseAllProjekts() {

  tableData.value.forEach((article) => {
    article.projectId = projectIdForAll.value;
  });
  for (let i = 0; i < tableData.value.length; i++) {
    onSelectProject(i);
  }

}

const readyToImport = computed(() => {
  let ready = true;
  tableData.value.forEach((article) => {

    //ingore articles that are not selected
    if (!article.import) {
      return;
    }

    if (article.projectId === 0 || article.magazineId === 0 || (article.markets.length > 0 && article.marketId === 0)) {
      ready = false;
    }
  });


  if (magazineId.value === 0) {
    ready = false;
  }

  return ready;
});

async function getMarketsWithIdAndName() {
  const [data, err] = await query.getMarketsWithIdAndName(magazineId.value);
  markets.value = data;
  await getProductsWithIdAndName();
  if (err) {
    console.error(err);
    return;
  }
}

async function getJob(jobId) {
  const [data, err] = await query.getJop(jobId);
  if (err) {
    console.error('Fehler beim Abrufen des JOP:', err);
  }
  processesBar.value = data.processed;

  if (data.processed === 100 && data.report.errors.length > 0) {
    eventBus.openModal(ShowReport, {
      title: "Report Meldung",
      errors: data.report.errors,
      messages: data.report.messages,
    });
  } else {
    location.reload();
  }
}

async function newsletterImport() {
  try {

    let newJSON = []
    let section = []
    let sectionNumber = 0
    let hasStarted = false // Flag um zu tracken, ob wir schon eine Überschrift hatten

    tableData.value.forEach((item, index) => {
      let obj = {
        articleNumber: item.articleNumber,
        cta: item.cta,
        banner: item.banner,
        header: item.header,
        magazineId: item.magazineId,
        marketId: item.marketId,
        projektId: item.projectId,
      }

      if (item.articleNumber.trim().toLowerCase() === "überschrift") {
        // Wenn es nicht die erste Überschrift ist, pushe die vorherige Sektion
        if (hasStarted && section.length > 0) {
          newJSON.push({
            section: section,
            number: sectionNumber
          })
        }
        // Starte neue Sektion
        section = []
        sectionNumber++
        hasStarted = true // Ab jetzt sammeln wir Artikel
      } else if (hasStarted) {
        // Füge Artikel nur hinzu, wenn wir schon eine Überschrift hatten
        section.push(obj)
      }
      // Alles vor der ersten Überschrift wird ignoriert
    })

    // Pushe die letzte Sektion, falls vorhanden
    if (hasStarted && section.length > 0) {
      newJSON.push({
        section: section,
        number: sectionNumber
      })
    }


    let ojk = {
      magazineId: magazineId.value,
      data: newsletterData.value
    }
    
    const newsletterImportArticles = []
    tableData.value.forEach((article, index) => {
      if (!article.import) {
        return;
      }
      newsletterImportArticles.push({
        articleNumber: article.articleNumber,
        magazineId: article.magazineId || 0,
        marketId: article.marketId || 0,
      });
    });
    
    const [data, err] = await mutation.newsletterImport(magazineId.value, newsletterImportArticles);
    if (err) {
      console.error(err);
      return;
    }
    const [_, error] = await mutation.saveNewsLetterImport(ojk);
    if (error) {
      console.error(error);
      return;
    }

    const intervalId = setInterval(() => {
      getJob(data.jopId);
      if (processesBar.value === 100) {
        clearInterval(intervalId);
      }
    }, 2000);
  } catch (error) {
    console.error('Fehler beim Importieren der Artikel:', error);
  }
}

function ignore(rowIndex) {
// set ignore on true or false
  tableData.value = tableData.value.filter((item) => item !== rowIndex);
}

async function getProjectsWithIdAndName() {
  const [data, err] = await query.getProjectsWithIdAndName();
  projekts.value = data;
  magazineId.value = 0
  if (err) {
    console.error(err);
    return;
  }
}

function onFileChange(event) {

  selectedFile.value = event.target.files[0];

  uploadFile();
}

const newsletterData = ref();
async function uploadFile() {
  loading.value = true;
  if (!selectedFile.value) {
    alert('Bitte wählen Sie eine Datei aus.');
    return;
  }

  const formData = new FormData();
  formData.append('file', selectedFile.value);

  try {
    const response = await axios.post('/api/v3/excel/import/newsletter/' + magazineId.value, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (response.data.articles.length > 0) {
      let tmp = response.data.articles;
      newsletterData.value = response.data.excelDataJSON;

      for (let i = 0; i < tmp.length; i++) {
        tmp[i].projectId = 0;
        tmp[i].magazineId = 0;
        tmp[i].marketId = 0;
        tmp[i].magazines = [];
        tmp[i].markets = [];
        tmp[i].import = true;
      }


      tableData.value = tmp;
      console.log("TABLE DATA:", tableData.value);
    }

  } catch (error) {
    console.error('Fehler beim Hochladen der Datei:', error);
    alert('Fehler beim Hochladen der Datei.');
  } finally {
    loading.value = false;
  }
}

async function getMagazinesWithIdAndName() {
  const [data, err] = await query.getMagazinesWithIdAndName(projectId.value);
  magazines.value = data;

  //magazineId.value = 0
  if (err) {
    console.error(err);
    return;
  }
}

function copySelectFromTopProject(rowIndex) {
  if (rowIndex > 0) {
    // wenn in der vorherigen Zeile kein projekt ausgewwählt wurde, dann nimm den index dafor
    for (let i = rowIndex - 1; i >= 0; i--) {
      if (tableData.value[i].projectId !== 0) {
        tableData.value[rowIndex].projectId = tableData.value[i].projectId;
        break;
      }
    }

  }
  onSelectProject(rowIndex)
}

function copySelectFromTopMagazine(rowIndex) {
  if (rowIndex > 0) {
    for (let i = rowIndex - 1; i >= 0; i--) {
      if (tableData.value[i].magazineId !== 0) {
        tableData.value[rowIndex].magazineId = tableData.value[i].magazineId;
        break;
      }
    }
  }
  onSelectMagazine(rowIndex)
}

async function onSelectProject(index) {
  const [data, err] = await query.getMagazinesWithIdAndName(tableData.value[index].projectId);
  if (err) {
    console.error(err);
    return;
  }

  tableData.value[index].magazines = data;
  tableData.value[index].magazineId = 0
}

async function onSelectMagazine(index) {
  const [data, err] = await query.getMarketsWithIdAndName(tableData.value[index].magazineId);
  if (err) {
    console.error(err);
    return;
  }


  tableData.value[index].markets = data;
  tableData.value[index].marketId = 0

  await checkIfArticleIsOnMagazine(index);
}

async function checkIfArticleIsOnMagazine(index) {
  const [data, err] = await mutation.checkIfArticleIsOnMagazinePage(tableData.value[index].magazineId, tableData.value[index].articleNumber);


  tableData.value[index].exists = data?.success;
  if (err) {
    console.error(err);
    return;
  }
}


</script>
